import { PostsComponent } from './posts.component';
export default PostsComponent;


// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/posts/index.ts